import React, { useId } from 'react';

import { HelperText } from '../HelperText';
import { InputAdornment } from '../InputAdornment';
import { Label } from '../Label';
import { TextFieldContainer } from '../TextFieldContainer';

import { StyledFormControl, StyledOutlinedInput } from './styles';
import { TTextField } from './types';

export const TextField = React.forwardRef<HTMLInputElement, TTextField>(
  (
    {
      id,
      label,
      error,
      helperText,
      startAdornment,
      endAdornment,
      sx,
      className,
      fullWidth = true,
      size = 'medium',
      ...otherProps
    },
    ref
  ) => {
    const generateId = useId();
    const inputId = id || `text-field-${generateId}`;
    const helperTextId = `helper-text-${generateId}`;

    return (
      <TextFieldContainer sx={sx} className={className} fullWidth={fullWidth}>
        {label ? (
          <Label id={inputId} error={error}>
            {label}
          </Label>
        ) : null}
        <StyledFormControl
          error={error}
          variant="outlined"
          size={size}
          {...otherProps}
        >
          <StyledOutlinedInput
            inputRef={ref}
            id={inputId}
            size={size}
            aria-describedby={helperText ? helperTextId : undefined}
            startAdornment={
              startAdornment ? (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              ) : null
            }
            endAdornment={
              endAdornment ? (
                <InputAdornment position="end">{endAdornment}</InputAdornment>
              ) : null
            }
            {...otherProps}
          />
          {helperText ? (
            <HelperText id={helperTextId}>{helperText}</HelperText>
          ) : null}
        </StyledFormControl>
      </TextFieldContainer>
    );
  }
);

TextField.displayName = 'TextField';
